import React, { useState, useEffect, useContext } from "react";
import { AudioContext } from "../context/AudioContext";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../config/config";
import { Link } from 'react-router-dom';
import { BusinessSettingsContext } from "../context/BusinessSettingsContext";

const SingleChannel = () => {
    const { slug } = useParams();
    const { setCurrentChannel } = useContext(AudioContext);
    
    const [channel, setChannel] = useState(null);
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [relatedChannels, setRelatedChannels] = useState([]);
    const { settings } = useContext(BusinessSettingsContext);
    // const [comments, setComments] = useState([]);
    // const [newComment, setNewComment] = useState("");
    // const user = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        const fetchChannelData = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${BASE_URL}/channel/${slug}`);
                if (!response.ok) throw new Error("Failed to fetch data");

                const data = await response.json();
                setChannel(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        const fetchRelatedChannels = async () => {
            try {
                const response = await fetch(`${BASE_URL}/channel/${slug}/related`);
                if (!response.ok) throw new Error("Failed to fetch data");
                
                const data = await response.json();
                setRelatedChannels(data);
            } catch (error) {
                console.error("Error fetching related channels:", error);
            }
        };

        // const fetchComments = async () => {
        //     try {
        //         const response = await fetch(`${BASE_URL}/channel/${id}/comments`);
        //         const data = await response.json();
        //         setComments(data);
        //     } catch (err) {
        //         console.error("Failed to fetch comments", err);
        //     }
        // }


        fetchChannelData();
        fetchRelatedChannels();
        // fetchComments();

        // Load history from sessionStorage
        const storedHistory = sessionStorage.getItem('radioHistory');
        if (storedHistory) {
            setHistory(JSON.parse(storedHistory));
        }

    }, [slug]);

    useEffect(() => {
        if (channel) {

            document.title = `${channel.name}` + ' | ' + settings.website_name || "Website Name";
            const updateOrCreateMetaTag = (name, content) => {
                let metaTag = document.querySelector(`meta[name='${name}']`);
                if (metaTag) {
                    metaTag.setAttribute("content", content);
                } else {
                    const newMetaTag = document.createElement("meta");
                    newMetaTag.name = name;
                    newMetaTag.content = content;
                    document.head.appendChild(newMetaTag);
                }
            };

            updateOrCreateMetaTag("description", settings.description || "Listen to Radio Online live streaming. Enjoy the best music and shows.");
            updateOrCreateMetaTag("keywords", settings.keywords || "Radio Online, online radio, streaming, live music");

            const updateOrCreateOGTag = (property, content) => {
                let ogTag = document.querySelector(`meta[property='${property}']`);
                if (ogTag) {
                    ogTag.setAttribute("content", content);
                } else {
                    const newOGTag = document.createElement("meta");
                    newOGTag.setAttribute("property", property);
                    newOGTag.content = content;
                    document.head.appendChild(newOGTag);
                }
            };

            updateOrCreateOGTag("og:title", settings.website_name || "Website Name");
            updateOrCreateOGTag("og:description", settings.description || "Listen to Radio Online live streaming. Enjoy the best music and shows.");
            updateOrCreateOGTag("og:image", settings.website_logo || "https://yourwebsite.com/default-image.jpg");
            updateOrCreateOGTag("og:url", window.location.href);
            updateOrCreateOGTag("og:type", "website");

            updateOrCreateMetaTag("twitter:card", settings.website_logo);
            updateOrCreateMetaTag("twitter:title", settings.website_name || "Website Name");
            updateOrCreateMetaTag("twitter:description", settings.description || "Listen to Radio Online live streaming. Enjoy the best music and shows.");
            updateOrCreateMetaTag("twitter:image", settings.website_logo || "https://yourwebsite.com/default-image.jpg");

    
            const metaDescription = document.querySelector("meta[name='description']");
            if (metaDescription) {
                metaDescription.setAttribute("content", `Listen to ${channel.name} live streaming. Enjoy the best music and shows.`);
            } else {
                const newMetaDescription = document.createElement("meta");
                newMetaDescription.name = "description";
                newMetaDescription.content = `Listen to ${channel.name} live streaming. Enjoy the best music and shows.`;
                document.head.appendChild(newMetaDescription);
            }
    
            const metaKeywords = document.querySelector("meta[name='keywords']");
            if (metaKeywords) {
                metaKeywords.setAttribute("content", `${channel.name}, online radio, streaming, live music`);
            } else {
                const newMetaKeywords = document.createElement("meta");
                newMetaKeywords.name = "keywords";
                newMetaKeywords.content = `${channel.name}, online radio, streaming, live music`;
                document.head.appendChild(newMetaKeywords);
            }
        }
    }, [channel]);
    
    

    const playChannel = (channel) => {
        if (!channel) return;

        setCurrentChannel(channel);

        let updatedHistory = [channel, ...history.filter(item => item.id !== channel.id)];
        if (updatedHistory.length > 5) updatedHistory.pop(); 

        setHistory(updatedHistory);
        sessionStorage.setItem("radioHistory", JSON.stringify(updatedHistory));
    };

    // const handleCommentSubmit = async () => {
    //     if (!newComment.trim()) {
    //         console.log("Empty comment");
    //         return;
    //     }
    
    //     console.log("Submitting comment:", newComment);
    
    //     try {
    //         const response = await fetch(`${BASE_URL}/channel/${id}/comments`, {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 // 'Authorization': `Bearer ${token}`,
    //             },
    //             body: JSON.stringify({ text: newComment })
    //         });
    
    //         const result = await response.json();
    //         console.log("Response:", result);
    
    //         if (!response.ok) {
    //             console.error("Error submitting comment:", result.message || result);
    //             return;
    //         }
    
    //         setComments((prev) => [...prev, result]);
    //         setNewComment("");
    //     } catch (err) {
    //         console.error("Error:", err);
    //     }
    // };
    

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <main class="main">
		<div class="container-fluid">
			<div class="row row--grid">

				<div class="col-12">
					<div class="main__title main__title--page text-capitalize">
                        <h1>{channel.name || "Unknown Channel"}</h1>
					</div>
				</div>

				<div class="col-12">
					<div class="release">
						<div class="release__content">
							<div class="release__cover">
								<img src={channel?.favicon || "Now Found"} alt=""/>
							</div>
							<div class="release__stat text-capitalize">
								<span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-translate" viewBox="0 0 16 16">
                                    <path d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286zm1.634-.736L5.5 3.956h-.049l-.679 2.022z"/>
                                    <path d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm7.138 9.995q.289.451.63.846c-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6 6 0 0 1-.415-.492 2 2 0 0 1-.94.31"/>
                                </svg> 
                                <Link style={{textDecoration: 'none', color: 'white'}} to={`/language/${channel.language}`}>{channel?.language || "Unknown"}</Link>
                                </span>
								<span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-globe" viewBox="0 0 16 16">
                                        <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539 7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539 7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z"/>
                                    </svg>
                                    <Link style={{textDecoration: 'none', color: 'white'}} to={`/country/${channel.countrycode}`}>{channel?.country || "Unknown"}</Link>
                                </span>
							</div>
							<Link to="" key={channel.id} onClick={() => playChannel(channel)} class="release__buy open-modal">

                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445"/>
                            </svg>
                                Play Now
                            </Link>
						</div>

						<div class="release__list">
                                <h4 className="text-white mb-3">Related Channels</h4>
							<ul class="main__list main__list--playlist main__list--dashbox">
                                {relatedChannels.slice(0, 5).map((channel) => (
                                    <li class="single-item">
                                        <Link data-playlist data-title={channel.name} data-artist={channel.name} data-img={channel.favicon} key={channel.id} onClick={() => playChannel(channel)} class="single-item__cover">
                                            <img src={channel.favicon} alt=""/>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z"/></svg>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z"/></svg>
                                        </Link>
                                        <div class="single-item__title text-capitalize">
                                            <h4><Link to={`/channel/${channel.slug}`}>{channel.name}</Link></h4>
                                            <span><Link to={`/language/${channel.language}`}>{channel.language}</Link></span>
                                        </div>
                                        <Link onClick={() => playChannel(channel)} class="single-item__export">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play" viewBox="0 0 16 16">
                                                <path d="M10.804 8 5 4.633v6.734zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696z"/>
                                            </svg>
                                        </Link>
                                        <span class="single-item__time">Live</span>
                                    </li>
                                 ))}
							</ul>
						</div>
					</div>
				</div>

				<div class="col-md-12">
					<div class="article">
						{/* article content */}
						<div class="article__content">
							<h4>About this channel</h4>

							<p dangerouslySetInnerHTML={{ __html: settings.description || "Channel Description will be here" }}></p>
						</div>
						{/* <!-- end article content --> */}

						{/* <!-- share --> */}
						<div class="share">
							<Link to="#" class="share__link share__link--fb"><svg width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.56341 16.8197V8.65888H7.81615L8.11468 5.84663H5.56341L5.56724 4.43907C5.56724 3.70559 5.63693 3.31257 6.69042 3.31257H8.09873V0.5H5.84568C3.1394 0.5 2.18686 1.86425 2.18686 4.15848V5.84695H0.499939V8.6592H2.18686V16.8197H5.56341Z"/></svg> share</Link>
							<Link to="#" class="share__link share__link--tw"><svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.55075 3.19219L7.58223 3.71122L7.05762 3.64767C5.14804 3.40404 3.47978 2.57782 2.06334 1.1902L1.37085 0.501686L1.19248 1.01013C0.814766 2.14353 1.05609 3.34048 1.843 4.14552C2.26269 4.5904 2.16826 4.65396 1.4443 4.38914C1.19248 4.3044 0.972149 4.24085 0.951164 4.27263C0.877719 4.34677 1.12953 5.31069 1.32888 5.69202C1.60168 6.22165 2.15777 6.74068 2.76631 7.04787L3.28043 7.2915L2.67188 7.30209C2.08432 7.30209 2.06334 7.31268 2.12629 7.53512C2.33613 8.22364 3.16502 8.95452 4.08833 9.2723L4.73884 9.49474L4.17227 9.8337C3.33289 10.321 2.34663 10.5964 1.36036 10.6175C0.888211 10.6281 0.5 10.6705 0.5 10.7023C0.5 10.8082 1.78005 11.4014 2.52499 11.6344C4.75983 12.3229 7.41435 12.0264 9.40787 10.8506C10.8243 10.0138 12.2408 8.35075 12.9018 6.74068C13.2585 5.88269 13.6152 4.315 13.6152 3.56293C13.6152 3.07567 13.6467 3.01212 14.2343 2.42953C14.5805 2.09056 14.9058 1.71983 14.9687 1.6139C15.0737 1.41264 15.0632 1.41264 14.5281 1.59272C13.6362 1.91049 13.5103 1.86812 13.951 1.39146C14.2762 1.0525 14.6645 0.438131 14.6645 0.258058C14.6645 0.22628 14.5071 0.279243 14.3287 0.374576C14.1398 0.480501 13.7202 0.639389 13.4054 0.734722L12.8388 0.914795L12.3247 0.565241C12.0414 0.374576 11.6427 0.162725 11.4329 0.0991699C10.8978 -0.0491255 10.0794 -0.0279404 9.59673 0.14154C8.2852 0.618204 7.45632 1.84694 7.55075 3.19219Z"/></svg> tweet</Link>
							<Link to="#" class="share__link share__link--vk"><svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.78479 8.92255C8.78479 8.92255 9.07355 8.89106 9.22145 8.73512C9.35684 8.59224 9.35214 8.32262 9.35214 8.32262C9.35214 8.32262 9.33414 7.06361 9.92967 6.87771C10.5166 6.69489 11.2702 8.09524 12.07 8.63372C12.6741 9.04085 13.1327 8.95174 13.1327 8.95174L15.2699 8.92255C15.2699 8.92255 16.3874 8.85495 15.8576 7.99231C15.8137 7.92164 15.5485 7.35397 14.269 6.1879C12.9284 4.9673 13.1084 5.16472 14.7221 3.05305C15.705 1.76715 16.0978 0.982093 15.975 0.646407C15.8584 0.325317 15.1353 0.410582 15.1353 0.410582L12.7297 0.425177C12.7297 0.425177 12.5513 0.401365 12.419 0.478949C12.2899 0.554996 12.2061 0.732441 12.2061 0.732441C12.2061 0.732441 11.8258 1.72721 11.3179 2.57372C10.2466 4.35892 9.81855 4.4534 9.64326 4.34279C9.23554 4.08392 9.33727 3.30424 9.33727 2.75039C9.33727 1.01973 9.60491 0.298431 8.81687 0.111769C8.5555 0.0495478 8.36299 0.00883541 7.6939 0.00192196C6.83543 -0.00652779 6.10921 0.00499461 5.69758 0.202411C5.42369 0.333767 5.2124 0.627203 5.34152 0.644103C5.50038 0.664843 5.86036 0.739354 6.0513 0.994383C6.29781 1.32392 6.2892 2.06289 6.2892 2.06289C6.2892 2.06289 6.43084 4.10005 5.95818 4.35277C5.6342 4.52638 5.1897 4.17226 4.2342 2.55221C3.7451 1.7226 3.37573 0.805416 3.37573 0.805416C3.37573 0.805416 3.30451 0.634117 3.17696 0.541938C3.02279 0.430555 2.80759 0.395987 2.80759 0.395987L0.521729 0.410582C0.521729 0.410582 0.178185 0.4198 0.0521924 0.566519C-0.0597138 0.696338 0.0435842 0.965961 0.0435842 0.965961C0.0435842 0.965961 1.8333 5.07638 3.86013 7.1481C5.71871 9.04699 7.8285 8.92255 7.8285 8.92255H8.78479Z"/></svg> share</Link>
						</div>
						{/* <!-- end share --> */}

						{/* <!-- comments --> */}
						{/* <div class="comments">
							<div class="comments__title">
                            <h4>Comments</h4>
                            <span>{comments.length}</span>
							</div>

							<ul className="comments__list">
                                {comments.map((comment, index) => (
                                    <li className="comments__item" key={index}>
                                        <div className="comments__autor">
                                            <img className="comments__avatar" src="/img/avatar.svg" alt="avatar" />
                                            <span className="comments__name">{user.name || user.email}</span>
                                            <span className="comments__time">{new Date(comment.created_at).toLocaleString()}</span>
                                        </div>
                                        <p className="comments__text">{comment.comment}</p>
                                    </li>
                                ))}
                            </ul>

							<form className="comments__form" onSubmit={(e) => { e.preventDefault(); handleCommentSubmit(); }}>
                                <div className="sign__group">
                                    <textarea
                                        id="text"
                                        name="text"
                                        className="sign__textarea"
                                        placeholder="Add comment"
                                        value={newComment}
                                        onChange={(e) => setNewComment(e.target.value)}
                                    />
                                </div>
                                <button type="submit" className="sign__btn">Send</button>
                            </form>
						</div> */}
						{/* <!-- end comments --> */}
					</div>
				</div>
			</div>
		</div>
        <div class="row">
            <div class="col-12">
                <div class="partners owl-carousel">
                    
                </div>
            </div>
        </div>
	</main>
    );
};

export default SingleChannel;
